module.exports = __webpack_public_path__ + "img/smiley_3.a0f1e6ea.png";